import React from 'react';
import styles from './index.module.scss';
import { BaseInfoProps } from '../..';
import { formatThousandUnit } from '@/utils/utils';

export interface ElectricCardProps {
  baseInfo?: BaseInfoProps;
}

// 尖峰平谷总
export enum ElectricCostType {
  SUMMIT = 'totalSummitCost', // 尖
  PEAK = 'totalPeakCost', // 峰
  PLAIN = 'totalPlainCost', // 平
  VALLEY = 'totalValleyCost', // 谷
}

export const ElectricCostTypeDisplay = {
  [ElectricCostType.SUMMIT]: '尖',
  [ElectricCostType.PEAK]: '峰',
  [ElectricCostType.PLAIN]: '平',
  [ElectricCostType.VALLEY]: '谷',
};
export const ElectricCostTypeColor = {
  [ElectricCostType.SUMMIT]: 'var(--mx-diagram17-color)',
  [ElectricCostType.PEAK]: 'var(--mx-diagram18-color)',
  [ElectricCostType.PLAIN]: 'var(--mx-diagram19-color)',
  [ElectricCostType.VALLEY]: 'var(--mx-diagram20-color)',
};

const ElectricCard = ({ baseInfo }: ElectricCardProps) => {
  return (
    <div className={styles.cardWrapper}>
      {Object.entries(ElectricCostType).map(([key, value]) => {
        return (
          <div key={key} className={styles.card} style={{ borderColor: ElectricCostTypeColor[value] }}>
            <div className={styles.unit}>{ElectricCostTypeDisplay[value]}-电费（元）</div>
            <div className={styles.num}>{formatThousandUnit(baseInfo?.[value])}</div>
          </div>
        );
      })}
    </div>
  );
};

export default ElectricCard;
